import { templatorLoader } from '@rankers/components/templator/templator_loader';
templatorLoader();

import { suppressNativeLongPressMenus } from '@rankers/lib/long_press_menu_suppressor';
suppressNativeLongPressMenus();

import { enableInstantActiveStates } from '@rankers/lib/instant_active_states';
enableInstantActiveStates();

import { analyticsListenerLoader } from '@rankers/components/analytics_listener/analytics_listener_loader';
analyticsListenerLoader();

import { analyticsWatcherLoader } from '@rankers/components/analytics_watcher/analytics_watcher_loader';
analyticsWatcherLoader();

import { pageHeadingLoader } from '@rankers/components/page_heading/page_heading_loader';
pageHeadingLoader();

import { dropdownLoader } from "@rankers/components/dropdown/dropdown_loader";
dropdownLoader();

import { carouselLoader } from '@rankers/components/carousel/carousel_loader';
carouselLoader();

import { progressiveImageLoader } from '@rankers/components/progressive_image/progressive_image_loader';
progressiveImageLoader();

import { directionsBtnLoader } from '@rankers/components/directions_btn/directions_btn_loader';
directionsBtnLoader();

import { breakpointerLoader } from '@rankers/components/breakpointer/breakpointer_loader';
breakpointerLoader();

import { togglerBtnsLoader } from '@rankers/components/toggler_btns/toggler_btns_loader';
togglerBtnsLoader();

import { reviewLoader } from '@rankers/components/review/review_loader';
reviewLoader();

import { avatarLoader } from '@rankers/components/avatar/avatar_loader';
avatarLoader();

import { moreFetcherLoader } from '@rankers/components/more_fetcher/more_fetcher_loader';
moreFetcherLoader();

import { starRatingLoader } from '@rankers/components/star_rating/star_rating_loader';
starRatingLoader();

import { ratingsGraphLoader } from '@rankers/components/ratings_graph/ratings_graph_loader';
ratingsGraphLoader();

import { popoverLoader } from '@rankers/components/popover/popover_loader';
popoverLoader();

import {collapserLoader} from "@rankers/components/collapser/collapser_loader";
collapserLoader();

import { DealsWidgetLoader } from "@rankers/components/deals_widget/loader";
DealsWidgetLoader();

import { promocodeLoader } from "@rankers/components/promocode/promocode_loader";
promocodeLoader();

import { suggestionPanelLoader } from "@rankers/components/suggestion_panel/suggestion_panel_loader";
suggestionPanelLoader();

import { clipboardCopyLoader } from "@rankers/components/clipboard_copy/clipboard_copy_loader";
clipboardCopyLoader();

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Import other component like modules.
// These don't use the `Component` class as a base.
// Although these are exposed on the window object (within the window.RankersModules namespace) they are generally not called outside this pack (instantiation is all that is required).
window.RankersModules = {};

import LazyLoader from '@rankers/components/lazy_loader';
window.RankersModules.lazyLoader = new LazyLoader();

import {hideFailedImages} from '@rankers/lib/hide_failed_images';
hideFailedImages();

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
